import React from 'react';
import { renderToString } from 'react-dom/server';
import { API } from '@editorjs/editorjs';

import addBlockAboveIcon from '../../../../assets/icons/add-block-above.svg';
import addBlockBelowIcon from '../../../../assets/icons/add-block-below.svg';
import {InstructionEvent} from "../types";

type Params = {
  api: API;
};

class BlockSettings {
  private api: API;

  private container: HTMLDivElement;
  
  constructor({ api } :Params) {
    this.container = document.createElement('div');
    this.api = api;
  }

  render(): HTMLDivElement {
    this.addBlockBelow();
    this.addBlockAbove();
    this.RemoveParagraphBlock();
    this.moveParagraphBlockUp();
    this.moveParagraphBlockDown();
    return this.container;
  }

  private RemoveParagraphBlock(){
    const timer = setTimeout(()=>{
      const removeButton = document.querySelector('.ce-settings__button--delete');
      const scriptInput: HTMLInputElement | null = document.querySelector('input[name=script]');
      const blockIndex = this.api.blocks.getCurrentBlockIndex();
      if(scriptInput && removeButton){
        const parsedEditorValue = JSON.parse(scriptInput.value);
        removeButton.addEventListener('click', ()=>{
          removeButton.addEventListener('click', ()=>{
            const blocks = parsedEditorValue.blocks.filter((item: any, i:number)=> i !== blockIndex);
            this.api.events.emit(InstructionEvent.SUBMIT_DATA, {editorText: JSON.stringify({...parsedEditorValue, blocks})});
          })
        })
        clearTimeout(timer);
      }
    }, 0);
  }

  private moveParagraphBlockUp(){
    const timer = setTimeout(()=>{
      const upButton = document.querySelector('.ce-tune-move-up');
      const scriptInput: HTMLInputElement | null = document.querySelector('input[name=script]');
      const blockIndex = this.api.blocks.getCurrentBlockIndex();
      if(scriptInput && upButton && blockIndex !== 0){
        upButton.addEventListener('click', ()=>{
            const parsedEditorValue = JSON.parse(scriptInput.value);
            const blocks = [...parsedEditorValue.blocks];
            blocks[blockIndex - 1] = parsedEditorValue.blocks[blockIndex];
            blocks[blockIndex] = parsedEditorValue.blocks[blockIndex - 1];
            console.log(parsedEditorValue.blocks, blocks, {...parsedEditorValue, blocks,}, parsedEditorValue.instructions);
            this.api.events.emit(InstructionEvent.SUBMIT_DATA, {editorText: JSON.stringify({...parsedEditorValue, blocks})});
            this.api.toolbar.close();
            this.api.toolbar.open();
        })
        clearTimeout(timer);
      }
    }, 0);
  }

  private moveParagraphBlockDown(){
    const timer = setTimeout(()=>{
      const downButton = document.querySelector('.ce-tune-move-down');
      const scriptInput: HTMLInputElement | null = document.querySelector('input[name=script]');
      const blockIndex = this.api.blocks.getCurrentBlockIndex();
      if(scriptInput && downButton && blockIndex < this.api.blocks.getBlocksCount() - 1){
        downButton.addEventListener('click', (e)=>{
          const parsedEditorValue = JSON.parse(scriptInput.value);
          const blocks = [...parsedEditorValue.blocks];
          blocks[blockIndex] = parsedEditorValue.blocks[blockIndex + 1];
          blocks[blockIndex + 1] = parsedEditorValue.blocks[blockIndex];
          this.api.events.emit(InstructionEvent.SUBMIT_DATA, {editorText: JSON.stringify({...parsedEditorValue, blocks})});
          this.api.toolbar.close();
          this.api.toolbar.open();
        })
        clearTimeout(timer);
      }
    }, 0);
  }

  private addBlockBelow() {
    const button = document.createElement('div');
    button.classList.add('cdx-settings-button');
    button.innerHTML = renderToString(<img src={addBlockBelowIcon} alt="" style={{ height: 20 }} />);
    const currentBlockIndex = this.api.blocks.getCurrentBlockIndex();
    if(currentBlockIndex !== 0)
    button.addEventListener('click', () => {
      const currentBlock = this.api.blocks.getBlockByIndex(currentBlockIndex);
      currentBlock.holder.className = 'ce-block';
      this.api.tooltip.hide();
      try {this.api.toolbar.close();} catch (e) {}
      this.api.blocks.insert(
        undefined,
        undefined,
        undefined,
        currentBlockIndex + 1,
        true,
      );
      this.api.caret.setToBlock(currentBlockIndex + 1);
      this.api.events.emit(InstructionEvent.SUBMIT_DATA, {});
    });

    this.api.tooltip.onHover(button, 'Add block below');
    this.container.appendChild(button);
  }

  private addBlockAbove() {
    const button = document.createElement('div');
    button.classList.add('cdx-settings-button');
    button.innerHTML = renderToString(<img src={addBlockAboveIcon} alt="" style={{ height: 20 }} />);

    button.addEventListener('click', () => {
      const currentBlockIndex = this.api.blocks.getCurrentBlockIndex();
      const currentBlock = this.api.blocks.getBlockByIndex(currentBlockIndex);
      currentBlock.holder.className = 'ce-block';
      this.api.tooltip.hide();
      try {this.api.toolbar.close();} catch (e) {}
      this.api.blocks.insert(
        undefined,
        undefined,
        undefined,
        currentBlockIndex,
        true,
      );
      this.api.caret.setToBlock(currentBlockIndex);
      this.api.events.emit(InstructionEvent.SUBMIT_DATA, {});
    });

    this.api.tooltip.onHover(button, 'Add block above');
    this.container.appendChild(button);
  }
}

export default BlockSettings;
